import { render, staticRenderFns } from "./AddOrderCollectionModal.vue?vue&type=template&id=3afc2c79&scoped=true&"
import script from "./AddOrderCollectionModal.vue?vue&type=script&lang=js&"
export * from "./AddOrderCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc2c79",
  null
  
)

export default component.exports